import React from 'react';
import { OverviewItemStyled, OverviewListStyled, } from '@yme/components/Destinations/ExperienceDetailsPage/components/ExperienceDetailsCard/components/Overview/styled';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { buildKey } from '@yme/utils/common';
export function Overview({ config, title, isRoundIcon }) {
    return (React.createElement("div", null,
        title && React.createElement(RegularTextLevel3, { weight: 500 }, title),
        React.createElement(OverviewListStyled, null, config.map(({ text, icon }, index) => text && (React.createElement(OverviewItemStyled, { as: "li", icon: icon, isRoundIcon: isRoundIcon, key: buildKey('key', index) }, text))))));
}
